// The endpoint TEMPLATE is what the store records and what the list filters on,
// but on a busy endpoint it makes every row read identically —
// `/v1/organizations/:organizationId/contacts/:id/types`, fifty times over, with
// no way to see which contact each row touched. Substituting the captured
// `pathParams` back into the template gives the concrete path an operator is
// actually looking for.
//
// Unsubstituted tokens are left standing rather than blanked: a `:param` still
// showing means nothing was captured for it, which is information, whereas an
// empty segment would silently read as a real (empty) path.
export function resolvedPath(endpoint: string, pathParams: Record<string, string> | null): string {
  if (pathParams === null) return endpoint;

  return endpoint.replace(/:([A-Za-z0-9_]+)/g, (token, name: string) => pathParams[name] ?? token);
}
